import { render, staticRenderFns } from "./DestinationsSilo.vue?vue&type=template&id=d721dbb6&scoped=true&"
import script from "./DestinationsSilo.vue?vue&type=script&lang=js&"
export * from "./DestinationsSilo.vue?vue&type=script&lang=js&"
import style0 from "./DestinationsSilo.vue?vue&type=style&index=0&id=d721dbb6&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721dbb6",
  null
  
)

export default component.exports